import { eAtlas, eUIAtlasFrame, Game } from "../../../../Game";
import { WrappedArray } from "../../../../Utils/Collections/WrapperArray";
import { AtlasUtils } from "../../../../Utils/Atlas/AtlasUtils";
import { Gameplay } from "../../../Gameplay";
import { LifeBarIcon } from "./LifeBarIcon";

export class LifeBar {
    static readonly ICON_SPACING = 50;

    static get instance(): LifeBar { return LifeBar._instance; }
    private static _instance: LifeBar;

    private _container: pc.Entity;
    private _icons: LifeBarIcon[];
    private _actIcons: WrappedArray<LifeBarIcon>;
    private _lifeCnt: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(parent: pc.Entity, batchGroupId: number) {
        LifeBar._instance = this;

        let atlas = Game.getAtlas(eAtlas.ui);

        // Pozadi pod ikonama micu
        let atlasRc = (atlas.frames[eUIAtlasFrame.lifeBarBg] as pc.TextureAtlasFrame).rect;
        let texRc = AtlasUtils.getTexFrameRegion(atlas.texture, atlasRc);

        this._container = new pc.Entity();
        this._container.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: atlasRc.z,
            height: atlasRc.w,
            anchor: new pc.Vec4(0, 0.5, 0, 0.5),
            pivot: new pc.Vec2(0, 0.5),
            rect: texRc,
            batchGroupId: batchGroupId
        });

        parent.addChild(this._container);
        this._container.setLocalPosition(20, 0, 0);

        // Ikony micu    
        this._icons = [];

        for (let i = 0; i < Game.settings.ballCnt; i++) {
            this._icons.push(new LifeBarIcon(i, this._container));
        }

        this._actIcons = new WrappedArray<LifeBarIcon>();

        // Zachytavat zmenu poctu zivotu
        Gameplay.instance.events.on(Gameplay.EVENT_LIFE_LOST, this.handleLifeLost, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._lifeCnt = Gameplay.instance.lifeCnt;

        for (let i = 0; i < this._lifeCnt; i++)
            this._icons[i].reset();

        this._actIcons.clear();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        this._actIcons.forEach((icon: LifeBarIcon): void => {
            if (!icon.update())
                this._actIcons.remove(false);
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleLifeLost(): void {
        let icon = this._icons[--this._lifeCnt];

        icon.hide();
        this._actIcons.add(icon);
    }
}